import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { IonContent, IonPage } from "@ionic/react";
import { Row, Col, Form, Divider } from "antd";

import log from "../utils/log";
import c from "../utils/common";
import _ from "lodash";

//
import useRequestStore from "../states/useRequest";
import useAuthStore from "../states/useAuth";

//
import Header from "../components/GetStarted/Header";
import SectionHeader from "../components/GetStarted/SectionHeader";
import CategorySelector from "../components/CategorySelector";
import Name from "../components/General/Name";
import AddressForm from "../components/Address/Form";
import LogoUploader from "../components/General/LogoUploader";
import Description from "../components/General/Description";

const GetStartedShop = () => {
  const history = useHistory();
  const { user } = useAuthStore();
  const { newCompany, newBrand, newShop, updateNewBrand, updateNewShop } = useRequestStore();

  const [brandForm] = Form.useForm();
  const [shopForm] = Form.useForm();

  const [shop, setShop] = useState(newShop);
  const [brand, setBrand] = useState(newBrand);

  const readOnly = useMemo(() => {
    let { shop: canUpdate } = user?.permission || {};
    // log.debug(canUpdate);
    return !canUpdate;
    // return false;
  }, [user]);

  const handleNextStep = async () => {
    //check form
    try {
      await brandForm.validateFields();
      await shopForm.validateFields();
    } catch (error) {
      log.error(error);
      return;
    }

    let { name: brandName, logo, description, category } = brand;
    let { name: shopName, address } = shop;
    // log.debug({ brandName, shopName, logo, category, address });

    //validate logo
    if (!logo) {
      return c.message({ type: "error", content: "Logo is required" });
    }

    let parsedBrand = {
      name: brandName?.trim(),
      logo,
      description,
      category,
    };

    let parsedShop = {
      name: shopName?.trim(),
      address,
    };

    log.debug(parsedBrand);
    log.debug(parsedShop);

    updateNewBrand("whole", parsedBrand);
    updateNewShop("whole", parsedShop);
    history.push({ pathname: "/get-started/shop/2" });
  };

  const updateBrandData = (newData) => {
    // log.debug(newData);
    setBrand((prev) => {
      // Create a copy of the previous shop data
      let updated = _.merge({}, prev, newData);

      // Overwrite the category if it exists in the new data
      if (newData.category) {
        updated.category = newData.category;
      }

      return updated;
    });
  };

  const updateShopData = (newData) => {
    // log.debug(newData);
    setShop((prev) => {
      // Create a copy of the previous shop data
      let updated = _.merge({}, prev, newData);
      return updated;
    });
  };

  return (
    <IonPage>
      <IonContent>
        <Header
          step={2}
          onBack={() => {
            history.goBack();
          }}
          onNext={() => {
            handleNextStep();
          }}
        />

        <Row justify="center" style={{ width: "100%" }}>
          <Row style={{ maxWidth: "50vw", padding: "20px" }}>
            <h1
              style={{ width: "100%", fontSize: "32px", fontWeight: "bold", marginBottom: "0.5rem" }}
              onClick={() => {
                log.debug(brand);
              }}
            >
              Create Your Branding
            </h1>
            <p style={{ color: "#666", marginBottom: "24px" }}>
              The following information will be visible to your customers in the mobile app.
            </p>

            <LogoUploader logo={brand?.logo} onFinish={updateBrandData} readOnly={readOnly} />

            <SectionHeader title="Brand Name" description="Provide name for your brand." />
            <Name
              state={{
                data: brand?.name,
                form: brandForm,
                rules: [{ required: true, message: "required" }],
                onChange: updateBrandData,
              }}
              readOnly={readOnly}
              maxLength={60}
              showCount
            />

            <SectionHeader title="About the Brand" />
            <Description
              state={{
                data: brand?.description,
                form: brandForm,
                rules: [{ required: true, message: "required" }],
                onChange: updateBrandData,
                keyName: "description",
              }}
              readOnly={readOnly}
              placeholder={"A brief description of your brand"}
            />

            <SectionHeader
              title="Category"
              description={readOnly ? null : "Select one or more categories that best describe your brand."}
            />
            <CategorySelector
              state={{
                data: brand?.category,
                form: brandForm,
                rules: [{ required: true, message: "required" }],
                onChange: updateBrandData,
              }}
              readOnly={readOnly}
            />

            <Divider />

            <SectionHeader title="Shop Name" description="Provide name for your shop." />
            <Name
              state={{
                data: shop?.name,
                form: shopForm,
                rules: [{ required: true, message: "required" }],
                onChange: updateShopData,
              }}
              readOnly={readOnly}
              placeholder={brand?.name ? `${brand.name} Shop A` : null}
              maxLength={60}
              showCount
            />

            <SectionHeader
              title="Shop Address"
              description="Where is your shop located?"
              extra={
                <span
                  style={{
                    color: "var(--ion-color-primary)",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    const { street, city, postalCode } = newCompany?.address || {};
                    if (street && city && postalCode) {
                      updateShopData({
                        address: {
                          street,
                          city,
                          postalCode,
                        },
                      });
                    }
                  }}
                >
                  copy company address
                </span>
              }
            />
            <AddressForm
              state={{ data: shop?.address, form: shopForm, onChange: updateShopData }}
              readOnly={readOnly}
            />
          </Row>
        </Row>
        <Row style={{ height: "5rem" }}></Row>
      </IonContent>
    </IonPage>
  );
};

export default GetStartedShop;
